import React from "react";

const Washing_8 = React.forwardRef(
  ({ width = "34", height = "30", viewBox = "0 0 34 30", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0.343054L4.48518 26.1041V29.1715H29.4852V26.1041L33.9704 0.343054L32 0L31.3896 3.50611C30.1276 4.3627 28.4244 4.77297 26.766 4.3153C26.1496 4.14519 24.455 3.3887 23.4472 2.88484L22.9282 2.62531L22.4453 2.94721C20.9416 3.94971 19.536 4.85069 17.5 4.85069C15.4677 4.85069 13.826 3.81001 12.5616 2.95184L11.9815 2.55812L11.4136 2.96925C10.7098 3.47879 8.77563 4.49859 7.46713 4.8933C6.79568 5.09584 5.71218 5.21578 4.64555 5.21418C4.12165 5.21339 3.63028 5.18319 3.22527 5.12719C3.07992 5.10709 2.95586 5.08497 2.85181 5.06269L1.97036 0L0 0.343054ZM3.21362 7.14076L6.48518 25.9313V27.1715H27.4852V25.9313L30.9596 5.97556C29.537 6.52966 27.8846 6.69876 26.234 6.24323C25.5337 6.04998 24.1021 5.41924 23.0756 4.92877C21.6628 5.85368 19.9192 6.85069 17.5 6.85069C15.1611 6.85069 13.2764 5.81195 11.9939 4.97741C10.9537 5.61003 9.29834 6.42993 8.04473 6.80808C7.10877 7.09041 5.80612 7.21593 4.64254 7.21417C4.14957 7.21343 3.66108 7.18988 3.21362 7.14076ZM15 18C15 19.1046 14.1046 20 13 20C11.8954 20 11 19.1046 11 18C11 16.8954 11.8954 16 13 16C14.1046 16 15 16.8954 15 18ZM21 20C22.1046 20 23 19.1046 23 18C23 16.8954 22.1046 16 21 16C19.8954 16 19 16.8954 19 18C19 19.1046 19.8954 20 21 20Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_8;
